import { render, staticRenderFns } from "./WasteStreamSelection.vue?vue&type=template&id=134df356&"
import script from "./WasteStreamSelection.vue?vue&type=script&lang=js&"
export * from "./WasteStreamSelection.vue?vue&type=script&lang=js&"
import style0 from "./WasteStreamSelection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports